export default __webpack_public_path__ + "static/media/list-view.d693b92f.svg";